import { APIProvider } from "./client";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./app";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <APIProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </APIProvider>,
);
